import React from 'react';
import AdminUserConversionsContainer from '../components/adminUserConversions.container';

/** `/admin/users/:userId/conversions` — one user's full conversion history, at its own URL. */
const AdminUserConversionsPage: React.FC = () => <AdminUserConversionsContainer />;

export default AdminUserConversionsPage;
